import { render } from "./contact-info.vue?vue&type=template&id=06fb6aae&scoped=true&ts=true"
import script from "./contact-info.vue?vue&type=script&lang=ts"
export * from "./contact-info.vue?vue&type=script&lang=ts"

import "./contact-info.vue?vue&type=style&index=0&id=06fb6aae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fb6aae"]])

export default __exports__